<div class="log-list-container" fxLayout="column" fxLayoutGap="15px">
  <div fxLayout="row" fxLayoutGap="15px">
    <div fxFlex="50" *ngIf="createdBy">
      <app-detail header="Utworzono przez" [value]="createdBy.firstName + ' ' + createdBy.lastName"
                  [link]="['/uzytkownicy/szczegoly', createdBy.uuid]"></app-detail>
    </div>

    <div fxFlex="50" *ngIf="!createdBy">
      <app-detail header="Utworzono przez" value="System"></app-detail>
    </div>

    <div fxFlex="50">
      <app-detail *ngIf="createdAt" header="Data utworzenia" [value]="createdAt | date:'y-MM-dd H:mm:ss'"></app-detail>
    </div>
  </div>
  <div fxLayout="column">
    <table mat-table [dataSource]="logs">

      <!-- Position Column -->
      <ng-container matColumnDef="user">
        <th mat-header-cell *matHeaderCellDef> Użytkownik </th>
        <td mat-cell *matCellDef="let element">
          <ng-container *ngIf="element.log.user">
            <div class="circular-image">
              <img class="circular-image small-avatar log-list-avatar"
                   [src]="'/rest/sso/api/user/' + element.log.user.uuid + '/avatar'" (error)="onImgError($event)"
                   alt="Zdjęcie"/>
            </div>
            <a class="default-link" [routerLink]="['/uzytkownicy/szczegoly', element.log.user.uuid]">{{element.log.user.firstName}} {{element.log.user.lastName}}</a>
          </ng-container>
          <ng-container *ngIf="!element.log.user">
            System
          </ng-container>
        </td>
      </ng-container>

      <ng-container matColumnDef="createdAt">
        <th mat-header-cell *matHeaderCellDef> Data </th>
        <td mat-cell *matCellDef="let element">
          {{element.log.createdAt | date:'y-MM-dd HH:mm:ss'}}
        </td>
      </ng-container>

      <ng-container matColumnDef="note">
        <th mat-header-cell *matHeaderCellDef> Notatka </th>
        <td mat-cell *matCellDef="let element" [innerHTML]="element.log.note">
        </td>
      </ng-container>

      <ng-container matColumnDef="field">
        <th mat-header-cell *matHeaderCellDef> Pole </th>
        <td mat-cell *matCellDef="let element">
          <ng-container *ngFor="let diff of element.diff">
            <ng-container *ngIf="diff.records">
              <ng-container *ngFor="let record of diff.records">
                <p><span class="log-field-name">{{diff.displayName}} > {{record.displayName}}</span></p>
              </ng-container>
            </ng-container>

            <ng-container *ngIf="!diff.records">
              <p><span class="log-field-name">{{diff.displayName}}</span></p>
            </ng-container>
          </ng-container>
        </td>
      </ng-container>

      <ng-container matColumnDef="previous">
        <th mat-header-cell *matHeaderCellDef> Przed </th>
        <td mat-cell *matCellDef="let element">
            <ng-container *ngFor="let diff of element.diff">

              <ng-container *ngIf="diff.displayName === 'Identyfikator' && (userPermissions | async).registration.id_import">
                <ng-container *ngIf="diff.records">
                  <ng-container *ngFor="let record of diff.records">
                    <p  class="p1"
                        >{{record.previous}}&nbsp;</p>
                  </ng-container>
                </ng-container>

                <ng-container *ngIf="!diff.records">
                  <p class="p1">{{diff.previous}}&nbsp;</p>
                </ng-container>
              </ng-container>

              <ng-container *ngIf="diff.displayName === 'Identyfikator' && !(userPermissions | async).registration.id_import">
                <ng-container >
                  <span class="limited-access"><mat-icon matTooltip="Brak dostępu do danych" matTooltipPosition="above">do_not_disturb</mat-icon></span>
                </ng-container>
              </ng-container>

              <ng-container *ngIf="diff.displayName !== 'Identyfikator'">
                <ng-container *ngIf="diff.records">
                  <ng-container *ngFor="let record of diff.records">
                    <p  class="p1"
                    >{{record.previous}}&nbsp;</p>
                  </ng-container>
                </ng-container>

                <ng-container *ngIf="!diff.records">
                  <p class="p1">{{diff.previous}}&nbsp;</p>
                </ng-container>
              </ng-container>

            </ng-container>
        </td>
      </ng-container>

      <ng-container matColumnDef="new">
        <th mat-header-cell *matHeaderCellDef> Po </th>
        <td mat-cell *matCellDef="let element">
          <ng-container *ngFor="let diff of element.diff">

            <ng-container *ngIf="diff.displayName === 'Identyfikator' && (userPermissions | async).registration.id_import">
              <ng-container *ngIf="diff.records">
                <ng-container *ngFor="let record of diff.records">
                  <p class="p1">{{record.new}}&nbsp;</p>
                </ng-container>
              </ng-container>

              <ng-container *ngIf="!diff.records">
                <p class="p1">{{diff.new}}&nbsp;</p>
              </ng-container>
            </ng-container>

            <ng-container *ngIf="diff.displayName === 'Identyfikator' && !(userPermissions | async).registration.id_import">
              <ng-container >
                <span class="limited-access"><mat-icon matTooltip="Brak dostępu do danych" matTooltipPosition="above">do_not_disturb</mat-icon></span>
              </ng-container>
            </ng-container>

            <ng-container *ngIf="diff.displayName !== 'Identyfikator'">
              <ng-container *ngIf="diff.records">
                <ng-container *ngFor="let record of diff.records">
                  <p class="p1">{{record.new}}&nbsp;</p>
                </ng-container>
              </ng-container>

              <ng-container *ngIf="!diff.records">
                <p class="p1">{{diff.new}}&nbsp;</p>
              </ng-container>
            </ng-container>

         </ng-container>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>

    <mat-paginator [pageSizeOptions]="[10, 20, 50,]" [length]="total"></mat-paginator>
  </div>
</div>
